export default __webpack_public_path__ + "static/media/pizza-slice.8b31530d.svg";